import { Logo } from '@hourly/components/Logo';
import { useAuth } from '@hourly/contexts/AuthContext';
import { Navigate, Outlet, useLocation } from 'react-router';
import styles from './Layout.module.css';

export default function Login() {
  const { pathname } = useLocation();
  const { isLoggedIn } = useAuth();

  const isAccessingViaDirectLogin = pathname.startsWith('/direct-login');

  if (isLoggedIn && !isAccessingViaDirectLogin) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Logo />
        <div className={styles.step}>
          <Outlet />
        </div>
      </div>
      <div className={styles.decorationArea}>
        <div className={styles.decoration}>
          <h1 className={styles.refer}>Refer. Track. Get paid.</h1>
          <span className={styles.description}>
            Drop a lead and track it from onboarding to payout—simple and transparent.
          </span>
        </div>
      </div>
    </div>
  );
}
